export default class CustomAreaData {
    constructor(id, theyrId, areaPoints, name, creationDate, lastUsedDate) {
        this.id = id
        this.theyrId = theyrId
        this.areaPoints = areaPoints
        this.name = name
        this.creationDate = creationDate
        this.lastUsedDate = lastUsedDate
    }
}